export const charge = {
  status: {
    applied: "申込中",
    application_paid: "申込金支払い済",
    paid: "支払い済",
    refund_applied: "返金依頼中",
    refunded: "返金済",
  },
};
